import { UUID } from './uuid';

const regions = {
    'us': 'https://s3.us-east-1.amazonaws.com/aws-assets-prod/libra-css/images/site/fav/favicon.ico',
    'cn': 'https://s3.cn-north-1.amazonaws.com.cn/aws-assets-prod/libra-css/images/site/fav/favicon.ico',
};

type regionName = keyof typeof regions;

async function ping(url: string) {
    const p = new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = reject;
        img.src = url;
    });

    await p;
}

export async function Closest(): Promise<regionName> {
    const promises: Promise<regionName>[] = [];

    for (const k of Object.keys(regions)) {
        const url = `${(regions as Record<string, string>)[k]}?cache-break=${UUID()}`;
        const p = new Promise<regionName>(resolve => {
            void ping(url).then(() => {
                resolve(k as regionName);
            }).finally(() => {
                void promises.splice(promises.indexOf(p));
            });
        });
        promises.push(p);
    }

    while (promises.length) {
        try {
            return await Promise.race(promises);
        } catch (err) {
            console.error(err);
        }
    }

    return 'us';
}